import {
    IsoDateTimeSchema,
    PaymentStatusSchema,
    UuidSchema
} from '@cookspace-shared-contracts/core';
import { z } from 'zod';

/**
 * Локальные Zod-схемы для admin-эндпоинтов /payments/*.
 * Admin-only DTO в shared-contracts не выносятся, поэтому форма повторяется
 * здесь и совпадает с admin-backend payments.mapper.ts.
 */

export const AdminUserSummarySchema = z.object({
    id: UuidSchema,
    email: z.string().nullable(),
    phoneNumber: z.string().nullable(),
    displayName: z.string().nullable()
});

export type AdminUserSummary = z.infer<typeof AdminUserSummarySchema>;

export const AdminTariffSummarySchema = z.object({
    id: UuidSchema,
    code: z.string(),
    name: z.string()
});

export type AdminTariffSummary = z.infer<typeof AdminTariffSummarySchema>;

export const AdminPaymentListItemSchema = z.object({
    id: UuidSchema,
    userId: UuidSchema,
    user: AdminUserSummarySchema.nullable(),
    subscriptionId: UuidSchema.nullable(),
    tariffId: UuidSchema.nullable(),
    tariff: AdminTariffSummarySchema.nullable(),
    amountRub: z.number(),
    currency: z.string(),
    status: PaymentStatusSchema,
    provider: z.string(),
    providerPaymentId: z.string(),
    description: z.string().nullable(),
    confirmationUrl: z.string().nullable(),
    paidAt: IsoDateTimeSchema.nullable(),
    cancelledAt: IsoDateTimeSchema.nullable(),
    refundedAt: IsoDateTimeSchema.nullable(),
    refundedAmountRub: z.number().nullable(),
    failureReason: z.string().nullable(),
    idempotenceKey: z.string(),
    createdAt: IsoDateTimeSchema,
    updatedAt: IsoDateTimeSchema
});

export type AdminPaymentListItem = z.infer<typeof AdminPaymentListItemSchema>;

export const AdminPaymentDetailsSchema = AdminPaymentListItemSchema;

export type AdminPaymentDetails = z.infer<typeof AdminPaymentDetailsSchema>;

export const ListPaymentsResponseSchema = z.object({
    items: z.array(AdminPaymentListItemSchema),
    total: z.number().int(),
    limit: z.number().int(),
    offset: z.number().int()
});

export type ListPaymentsResponse = z.infer<typeof ListPaymentsResponseSchema>;

export const GetPaymentResponseSchema = z.object({
    payment: AdminPaymentDetailsSchema
});

export type GetPaymentResponse = z.infer<typeof GetPaymentResponseSchema>;

export const RefundPaymentRequestSchema = z.object({
    amount: z.number().int().min(1).optional(),
    reason: z.string().min(10).max(1000)
});

export type RefundPaymentRequest = z.infer<typeof RefundPaymentRequestSchema>;

export const RefundPaymentResponseSchema = z.object({
    payment: AdminPaymentDetailsSchema
});

export type RefundPaymentResponse = z.infer<typeof RefundPaymentResponseSchema>;

export const ListPaymentsFiltersSchema = z.object({
    status: PaymentStatusSchema.optional(),
    search: z.string().optional(),
    userId: UuidSchema.optional(),
    limit: z.number().int().min(1).max(100).optional(),
    offset: z.number().int().min(0).optional()
});

export type ListPaymentsFilters = z.infer<typeof ListPaymentsFiltersSchema>;

export { PaymentStatusSchema };
